import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { catchError, delay, finalize, forkJoin, from, Observable, of, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { RoleService } from '../services/api/role.service';
import { LoaderService } from '../services/loader.service';
import { environment } from '@environments/environment';
import { Route } from '../models/enums/Route.enum';
import { SharedService } from '../services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class RoleResolver implements Resolve<any> {
  constructor(
    private readonly authService: AuthService,
    private readonly roleService: RoleService,
    private readonly loaderService: LoaderService,
    private readonly sharedService: SharedService,
  ) { }

  /**
   * Questo resolver serve a bloccare la renderizzazione delle pagine protette prima che venga
   * caricato il ruolo dell'utente loggato.
   *
   * @param route
   * @param state
   * @returns
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    /**
     * Controllo se il ruolo è stato già settato per evitare di invocare più volte l'API
     * ogni volta che si esce e si rientra nella sezione protetta.
    */
    if (this.authService.user?.role) {
      //In questo caso ho il ruolo settato, emitto true per sbloccare la rotta
      return of(true);
    }
    //In questo caso non ho il ruolo, provedo ad invocare l'API per ottenerlo e settarlo
    this.loaderService.show();
    return this.roleService.getRole()
      .pipe(
        tap((userConf) => {
          this.authService.setUserRole(userConf)
        }),
        delay(1000),
        catchError((e) => {
          this.sharedService.navigateTo_ErrorPage(() => console.log('error_page'));
          return of(e);
        }),
        finalize(() => this.loaderService.hide())
      );
  }
}
